<!-- Step 2 - time slot selection if normal birthday, others default to fixed slot -->
<script>
    import {onMount} from 'svelte';
    import { fade } from 'svelte/transition';
    import isLoading from '../stores/loading-store';
    import {reservation, steps} from '../stores/reservation-store';
    import FormNavigation from './event-form-navigation.svelte';
    import RecapTable from './recap-table.svelte';
    import getTimeBlocks from "../utils/get-timeblocks";
    import {
        i18nStore,
    } from "svelte-translate";
    const urlParams = new URLSearchParams(window.location.search);

    const feedTimeBlocksUrl = `/${$i18nStore.language}/api/timeblocks/`;

    let timeBlocks = null;

    onMount(async () => {
        $steps.previousStep = 1;
        $steps.nextStep = 3;
        $steps.nextStepAllowed = !!$reservation.timeSlot;
        let response = await getTimeBlocks(feedTimeBlocksUrl, $reservation.duration, $reservation.numJumpers, $reservation.eventType, $reservation.jumpDate, $reservation.parkId);
        timeBlocks = response['timeblocks'];
        isLoading.set(false);
    });


    const clearSelectedTimeBlock = () => {
        const selected = document.querySelector('.Timeblock--selected');
        if(selected){
            $steps.nextStepAllowed=false;
            selected.classList.remove('Timeblock--selected');
        }
    };

    const selectTimeBlock = (e, block) => {
        if (block.bookable && block.fill_level !== 'full') {
            clearSelectedTimeBlock();
            $reservation.timeSlot=block.start_hour;
            $steps.nextStepAllowed=true;
        }
    };
</script>

<div out:fade="{{delay: 0, duration: 150 }}" in:fade="{{delay: 500, duration: 200 }}" class="pb-4">
    <form class="Form-container">
        <div class="Form-split">
        <RecapTable />
        </div>
        <div class="Form-split">
        {#if timeBlocks}
        <ul class="Timeblocks">
        {#each timeBlocks as timeBlock}
            <li class="Timeblock" class:Timeblock--selected="{timeBlock.start_hour === $reservation.timeSlot}" class:Timeblock--non-bookable="{!timeBlock.bookable}" class:Timeblock--fill--low="{timeBlock.bookable && timeBlock.fill_level=='low'}" class:Timeblock--fill--light="{timeBlock.bookable && timeBlock.fill_level=='light'}" class:Timeblock--fill--medium="{timeBlock.bookable && timeBlock.fill_level=='medium'}" class:Timeblock--fill--high="{timeBlock.bookable && timeBlock.fill_level=='high'}" class:Timeblock--fill--full="{timeBlock.bookable && timeBlock.fill_level=='full'}" on:click|stopPropagation="{(e) => selectTimeBlock(e, timeBlock)}">
                {timeBlock.start_hour}:00 - {timeBlock.end_hour}:00
            </li>
        {/each}
        </ul>
        {/if}
            </div>
    </form>
    <FormNavigation />
</div>

